import { z } from "zod";

export const BOOKING_STATUS = ["richiesta", "confermata", "completata", "annullata"] as const;
export type BookingStatus = (typeof BOOKING_STATUS)[number];

export const BOOKING_SLOT = ["mattina", "pomeriggio", "sera"] as const;

/** Public viewing-request form payload. */
export const BookingInput = z.object({
  name: z.string().min(2).max(120),
  email: z.string().email(),
  phone: z.string().max(40).optional(),
  lang: z.enum(["it", "en", "de"]).default("it"),
  listing_id: z.string().uuid().optional(),
  preferred_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
  preferred_slot: z.enum(BOOKING_SLOT).optional(),
  message: z.string().max(2000).optional(),
  consents: z.object({
    privacy: z.literal(true),
    marketing: z.boolean().default(false),
  }),
  turnstile_token: z.string().min(10),
});
export type BookingInput = z.infer<typeof BookingInput>;

/** Admin update payload. */
export const BookingPatchInput = z.object({
  status: z.enum(BOOKING_STATUS).optional(),
  assigned_to: z.string().uuid().nullable().optional(),
});
export type BookingPatchInput = z.infer<typeof BookingPatchInput>;
